import { Address, Factory, FactoryIndex } from "impermax-sdk";
import React from "react";
import { Card } from "react-bootstrap";
import { useClaimsAll } from "../../hooks/useClaims";
import useGenericCall from "../../hooks/useGenericCall";
import { useOnchainAccount } from "../../hooks/useOnchain";
import { formatFloat } from "../../utils/format";
import InteractionButton from "../InteractionButton";
import "./index.scss";

export default function MassHarvest() {
  const data = useGenericCall(useOnchainAccount(), async onchainAccount => {
    const offchainAccount = onchainAccount.getOffchainAccount();
    const borrowPositions = await offchainAccount.getBorrowPositions() ?? {};
    return {
      borrowPositions, 
      massAvailableReward: await onchainAccount.getMassAvailableReward(borrowPositions)
    }
  });

  const pairsToClaim: FactoryIndex<Address[]> = {};
  const totalReward: {[key in string]: number} = {};
  let toClaimCounter = 0;
  if (data) {
    for (const factory of Object.keys(data.borrowPositions) as Factory[]) {
      if (!data.massAvailableReward) break;
      pairsToClaim[factory] = [];
      for (const pairAddress of data.borrowPositions[factory]) {
        if (!data.massAvailableReward[factory]) continue;
        const rewards = data.massAvailableReward[factory][pairAddress];
        if (rewards.length === 1 && rewards[0].amount < 1 || rewards.length === 0) continue;
        pairsToClaim[factory].push(pairAddress);
        toClaimCounter++;
        for (const reward of rewards) {
          if (!totalReward[reward.symbol]) totalReward[reward.symbol] = 0;
          totalReward[reward.symbol] += reward.amount;
        }
      }
    }
  }
  const [claimsState, onClaims] = useClaimsAll(pairsToClaim);

  if (!data) return (null);

  return (
    <Card className="mass-harvest text-center mt-5 p-3">
      <b>Pending reward:</b>
      { !data.massAvailableReward || Object.keys(data.massAvailableReward).length !== Object.keys(data.borrowPositions).length 
      ? "Loading..." : toClaimCounter === 0 ? "0 IBEX" : 
        (<>
          {Object.keys(totalReward).map((symbol, key) => (
            <div key={key}>
              {formatFloat(totalReward[symbol], 6)} {symbol}<br/>
            </div>
          ))}
          <InteractionButton 
            name={"Harvest All"} 
            onCall={onClaims}
            state={claimsState}
          />  
        </>)
      }
    </Card>
  );
}